<template>
    <ThSpacer :size="data.spacing" />
</template>

<script setup lang="ts">
import type { ComponentGlobalSpacerFragment } from '@/graphql/api'

import ThSpacer from '@/components/ui/ThSpacer.vue'

defineProps<{
    data: ComponentGlobalSpacerFragment
}>()
</script>
